// Code review - In Progress
// Documentation - In Progress
import { useEffect } from "react";
import { mainTable } from "../css/Common";
import { useState } from "react";
import {
  languageMasterExportHeader,
  languageMasterHeader,
} from "../components/HeaderAttribute";
import MainLayout from "../components/MainLayout";
import InputText from "../ReusableComponents/InputText";
import MainPopup from "../popup-containers/MainPopup";
import LanguagePopup from "../popup-containers/LanguagePopup";
import toast from "react-hot-toast";
import * as XLSX from "sheetjs-style";
import { BindAPI, IUDAPI } from "../services/APIConnection";
import GridPage from "../components/GridPage";
import AddScreenTitle from "../components/AddScreenTitle";
import Buttons from "../components/Buttons";
import Loader from "../ReusableComponents/Loader";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import PopUpButtons from "../components/PopUpButtons";
import { useLocation } from "react-router-dom";
import ErrorPopup from "../ReusableComponents/ErrorPopup";

const LanguageMaster = () => {
  const location = useLocation();
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [addScreenTitle, setAddScreenTitle] = useState(false);
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);
  const [popUpOpen, setpopUpOpen] = useState(false);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  const [rowIndex, setRowIndex] = useState("");
  const [bindLanguageMasterDatas, setBindLanguageMasterDatas] = useState([]);
  const [mstLanguageId, setMstLanguageId] = useState("");
  const [languageData, setLanguageData] = useState("");

  //popup title state

  const [viewDetails, setViewDetails] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    getLanguageData();
  }, []);

  const getLanguageData = async () => {
    setIsLoading(true);
    try {
      const response = await BindAPI("LanguageAPI/GetLanguage");
      setBindLanguageMasterDatas(response?.data?.Table ?? []);
    } catch (error) {
      console.error("Error fetching languages:", error);
      setBindLanguageMasterDatas([]); // fallback in case of error
    } finally {
      setIsLoading(false);
    }
  };

  const showAdd = () => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(true);
    setUpdateScreenTitle(false);
  };

  const cancel = () => {
    getLanguageData();
    setIsLoading(false);
    setVisibleAdd(false);
    setVisibleTable(true);
    handleOpen(false);
    setSubmitBtnDisabled(false);
    setIsLoading(false);
    setLanguageFields({
      language: "",
      languageCode: "",
    });

    setLanguageFieldsError({
      languageError: "",
      languageCodeError: "",
    });
  };
  //Value store States
  const [languageFields, setLanguageFields] = useState({
    language: "",
    languageCode: "",
  });

  const [languageFieldsError, setLanguageFieldsError] = useState({
    languageError: "",
    languageCodeError: "",
  });

  const validate = (flag) => {
    const errors = {};
    if (flag === 1 || flag === 2) {
      if (!languageFields.language.trim()) {
        errors.language = "Enter language";
      } else if (!/^[A-Za-z ]+$/.test(languageFields.language)) {
        errors.language = "Only alphabet and space allowed";
      }
      if (!languageFields.languageCode.trim()) {
        errors.languageCode = "Enter language Code";
      } else if (
        !/^[a-z]{2}(-[A-Za-z ]{2})?$/.test(languageFields.languageCode)
      ) {
        errors.languageCode =
          "Language code has to be in 2 letters and lowercase";
      }
    }
    setLanguageFieldsError({
      ...languageFieldsError,
      languageError: errors.language || "",
      languageCodeError: errors.languageCode || "",
    });
    return errors;
  };

  const handleSubmit = async (items, flag) => {
    setSubmitBtnDisabled(true);
    const validation = validate(flag);
    if (Object.keys(validation).length !== 0) {
      setIsOpen(true);
    }
    if (Object.keys(validation).length === 0) {
      setIsOpen(false);
      setIsLoading(true);
      var createdBy = sessionStorage.getItem("createdBy");
      if (flag == 1) {
        const languagePayload = [
          {
            languageKey: languageFields.languageCode,
            language: languageFields.language,
            createdBy: createdBy,
            flag: flag,
          },
        ];
        const response = await IUDAPI(
          languagePayload,
          "LanguageAPI/IUDLanguage",
        );
        if (response.data.Table[0].Result == "S") {
          toast.success("Language added successfully! 👍", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
          getLanguageData();
        } else {
          toast.error(
            " Language addition failed. Please review the details and try again. 👎",
            {
              duration: 1000,
              position: "top-center",
            },
          );
          setTimeout(cancel, 1000);
        }
      } else if (flag == 2) {
        const languagePayload = [
          {
            mstLanguageId: mstLanguageId,
            languageKey: languageFields.languageCode,
            language: languageFields.language,
            createdBy: createdBy,
            flag: flag,
          },
        ];

        const response = await IUDAPI(
          languagePayload,
          "LanguageAPI/IUDLanguage",
        );
        if (response.data.Table[0].Result == "M") {
          toast.success("Language Modified successfully! 👍", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
          getLanguageData();
        } else {
          toast.error(
            " Language modify failed. Please review the details and try again. 👎",
            {
              duration: 1000,
              position: "top-center",
            },
          );
          setTimeout(cancel, 1000);
        }
      } else {
        const languagePayload = [
          {
            mstLanguageId: bindLanguageMasterDatas[items].MstLanguageId,
            createdBy: createdBy,
            flag: flag,
          },
        ];
        const response = await IUDAPI(
          languagePayload,
          "LanguageAPI/IUDLanguage",
        );
        if (flag == 3) {
          if (response.data.Table[0].Result == "D") {
            toast.success("Deletion successful! 🗑️", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
            getLanguageData();
          } else {
            toast.error(
              " Language delete failed. Please review the details and try again. ❌",
              {
                duration: 1000,
                position: "top-center",
              },
            );
            setTimeout(cancel, 1000);
          }
        } else if (flag == 4) {
          if (response.data.Table[0].Result == "B") {
            toast.success("Language blocked successfully. 🔒", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
            getLanguageData();
          } else {
            toast.error(
              "Language block failed. Please review the details and try again.",
              {
                duration: 1000,
                position: "top-center",
              },
            );
            setTimeout(cancel, 1000);
          }
        } else if (flag == 5) {
          if (response.data.Table[0].Result == "UB") {
            toast.success("Language unblocked successfully. 🔓", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
            getLanguageData();
          } else {
            toast.error(
              "Language unblocked failed. Please review the details and try again.",
              {
                duration: 1000,
                position: "top-center",
              },
            );
            setTimeout(cancel, 1000);
          }
        }
      }
    } else {
      setSubmitBtnDisabled(false);
    }
  };
  const createdBy = sessionStorage.getItem("createdBy");
  const handleEdit = (rowIndex) => {
    setAddScreenTitle(false);
    setUpdateScreenTitle(true);
    setUpdateScreenTitle(true);
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(false);

    setLanguageFields({
      language: bindLanguageMasterDatas[rowIndex].Language,
      languageCode: bindLanguageMasterDatas[rowIndex].LanguageKey,
    });
    setMstLanguageId(bindLanguageMasterDatas[rowIndex].MstLanguageId);
    setLanguageData(bindLanguageMasterDatas[rowIndex]);
  };

  const handleOpen = (isOpen) => {
    setpopUpOpen(isOpen);
  };
  useEffect(() => {
    if (location.pathname == "/languagemaster") {
      setAddScreenTitle(false);
      setVisibleTable(true);
      setVisibleAdd(false);
      getLanguageData();
    }
  }, [location]);
  const handleLanguagePopUp = (rowIndex, flag) => {
    handleOpen(true);
    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
      setRowIndex(rowIndex);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setBlockDetails(false);
      setUnBlockDetails(false);
      setRowIndex(rowIndex);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(true);
      setUnBlockDetails(false);
      setRowIndex(rowIndex);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(true);
      setRowIndex(rowIndex);
    }
    setLanguageData(bindLanguageMasterDatas[rowIndex]);
  };
  const handleExport = async () => {
    try {
      const response = await BindAPI("LanguageAPI/BindLanguageExport");
      const rows = response?.data?.Table || [];
      if (rows.length === 0) {
        await IUDAPI(
          {
            mstUserId: parseInt(createdBy, 10),
            sp: "LANGUAGE MASTER",
            action: "EXCEL EXPORT",
            status: "FAILED",
            tableName: "mst_language",
            description: "No data available to export",
          },
          "Log/IUDLog",
        );

        toast.error("No data available to export", {
          duration: 1000,
          position: "top-center",
        });

        return;
      } else {
        await IUDAPI(
          {
            mstUserId: parseInt(createdBy, 10),
            sp: "LANGUAGE MASTER",
            action: "EXCEL EXPORT",
            status: "SUCCESS",
            tableName: "mst_language",
            description: `Language Master Excel exported successfully. Total Records: ${rows.length}`,
          },
          "Log/IUDLog",
        );
      }
      exportData(
        languageMasterExportHeader.map((col) => col.title),
        rows,
      );
    } catch (error) {
      console.error("Export error", error);
      await IUDAPI(
        {
          mstUserId: parseInt(createdBy, 10),
          sp: "LANGUAGE MASTER",
          action: "EXCEL EXPORT",
          status: "FAILED",
          tableName: "mst_language",
          description: "Error occurred while exporting Language Master data",
        },
        "Log/IUDLog",
      );
      toast.error("Failed to export data", {
        duration: 1000,
        position: "top-center",
      });
    }
  };

  const exportData = (columns, rows) => {
    /* ---------- TITLE ---------- */
    const titleRow = [
      {
        v: "Language Master",
        s: {
          font: { bold: true, sz: 16 },
          alignment: { horizontal: "left" },
        },
      },
    ];

    const spacingRow = [{ v: "" }];

    /* ---------- HEADER ---------- */
    const headerRow = columns.map((col) => ({
      v: col,
      s: {
        fill: { fgColor: { rgb: "2D2D6E" } },
        font: { bold: true, color: { rgb: "FFFFFF" } },
        alignment: { horizontal: "left", wrapText: true },
      },
    }));

    /* ---------- DATA ROWS ---------- */
    const dataRows = rows.map((row, index) => {
      const baseStyle =
        index % 2 === 1 ? { fill: { fgColor: { rgb: "F2F2F2" } } } : {};

      return [
        { v: index + 1, s: baseStyle }, // S.No
        { v: row.MstLanguageId, s: baseStyle },
        { v: row.Language, s: baseStyle },
        { v: row.LanguageCode, s: baseStyle },
        { v: row.FullName_en, s: baseStyle },
      ];
    });

    /* ---------- SHEET DATA ---------- */
    const wsData = [titleRow, spacingRow, headerRow, ...dataRows];

    const ws = XLSX.utils.aoa_to_sheet(wsData);

    /* ---------- DYNAMIC COLUMN WIDTHS (CORRECT) ---------- */
    ws["!cols"] = columns.map((header, colIndex) => {
      // start with header text length
      let maxLength = header?.length || 10;

      // check each exported row
      dataRows.forEach((rowArray) => {
        const cell = rowArray[colIndex]?.v;

        if (cell !== null && cell !== undefined) {
          maxLength = Math.max(maxLength, cell.toString().length);
        }
      });

      return {
        width: Math.min(Math.max(maxLength + 2, 10), 40),
      };
    });

    /* ---------- ROW HEIGHTS ---------- */
    ws["!rows"] = [
      { hpt: 30 }, // Title
      { hpt: 15 }, // Space
      { hpt: 22 }, // Header
      ...Array(rows.length).fill({ hpt: 18 }),
    ];

    /* ---------- BORDERS ---------- */
    const range = XLSX.utils.decode_range(ws["!ref"]);
    for (let R = range.s.r; R <= range.e.r; R++) {
      for (let C = range.s.c; C <= range.e.c; C++) {
        const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
        if (!ws[cellRef]) continue;

        ws[cellRef].s = {
          ...ws[cellRef].s,
          border: {
            top: { style: "thin", color: { rgb: "000000" } },
            bottom: { style: "thin", color: { rgb: "000000" } },
            left: { style: "thin", color: { rgb: "000000" } },
            right: { style: "thin", color: { rgb: "000000" } },
          },
        };
      }
    }

    /* ---------- WORKBOOK ---------- */
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Language Master");

    XLSX.writeFile(wb, "Language_Master.xlsx");
  };

  return (
    <MainLayout pageName="2">
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />

      {visibleTable && (
        <GridPage
          title="Language Master"
          header={languageMasterHeader}
          records={bindLanguageMasterDatas}
          handleEdit={handleEdit}
          handleAction={handleLanguagePopUp}
          handleExportBtn={true}
          handleExport={handleExport}
          showAdd={showAdd}
          blockView={true}
          addView={true}
        />
      )}
      {visibleAdd && (
        <div class="flex flex-col w-full">
          <div class={mainTable.mainAddScreen}>
            <AddScreenTitle
              addScreenTitle={addScreenTitle}
              updateScreenTitle={updateScreenTitle}
              title="Language Master"
            />
          </div>

          <div class="mx-auto  md:w-2/5 w-full border-black">
            <div class="relative w-full h-full max-w-xl md:h-auto">
              <div class="relative bg-white rounded-lg shadow ">
                <div class="px-6 py-6 lg:px-8">
                  <form class="space-y-6" action="#">
                    <div class="flex w-full gap-6">
                      <div class="w-full">
                        <div class={`mb-2`}>
                          <InputText
                            inputType="text"
                            title="language"
                            name="language"
                            classStar={"text-red-400"}
                            content={languageFields.language}
                            controlFunc={(e) =>
                              setLanguageFields({
                                ...languageFields,
                                language: e.target.value,
                              })
                            }
                            controlFuncBlur={(e) => {
                              setLanguageFieldsError((languageFieldsError) => ({
                                ...languageFieldsError,
                                languageError:
                                  languageFields.language &&
                                  languageFields.language.length > 0
                                    ? /^[A-Za-z ]+$/.test(
                                        languageFields.language,
                                      )
                                      ? ""
                                      : "Only Alphabet and space allowed"
                                    : "Enter Language",
                              }));
                            }}
                            errorMessage={languageFieldsError.languageError}
                          />
                        </div>
                        <div>
                          <InputText
                            inputType="text"
                            title="Language Code"
                            name="languageCode"
                            classStar={"text-red-400"}
                            content={languageFields.languageCode}
                            controlFunc={(e) =>
                              setLanguageFields({
                                ...languageFields,
                                languageCode: e.target.value,
                              })
                            }
                            controlFuncBlur={(e) => {
                              setLanguageFieldsError((languageFieldsError) => ({
                                ...languageFieldsError,
                                languageCodeError:
                                  languageFields.languageCode &&
                                  languageFields.languageCode.length > 0
                                    ? /^[a-z]{2}(-[A-Za-z ]{2})?$/.test(
                                        languageFields.languageCode,
                                      )
                                      ? ""
                                      : "Language code has to be in 2 letters and lowercase"
                                    : "Enter Language Code",
                              }));
                            }}
                            errorMessage={languageFieldsError.languageCodeError}
                          />
                        </div>
                      </div>
                    </div>

                    <Buttons
                      addScreenTitle={addScreenTitle}
                      updateScreenTitle={updateScreenTitle}
                      handleSubmit={handleSubmit}
                      cancel={cancel}
                      disabledBtn={submitBtnDisabled ? true : false}
                    />
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}
      <MainPopup
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={handleLanguagePopUp}
      >
        <div>
          <PopUpScreenTitle
            title="Language Master"
            setpopUpOpen={setpopUpOpen}
            viewDetails={viewDetails}
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
          />

          <LanguagePopup data={languageData} />
        </div>

        <PopUpButtons
          deleteDetails={deleteDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}
          rowIndex={rowIndex}
          handleSubmit={handleSubmit}
          cancel={cancel}
          disabledBtn={submitBtnDisabled ? true : false}
        />
      </MainPopup>
    </MainLayout>
  );
};

export default LanguageMaster;
